if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

if (!customElements.get("product-options")) {
  var _html = `<li class="thumbnail-list__item media swiper-slide" data-media-position="[position]">
		  <img src="[image]&amp;width=416" alt="[title]" 
		  srcset="[image]&amp;width=54 54w, 
		  [image]&amp;width=74 74w, 
		  [image]&amp;width=104 104w, 
		  [image]&amp;width=162 162w, 
		  [image]&amp;width=208 208w, 
		  [image]&amp;width=324 324w, 
		  [image]&amp;width=416 416w" 
		  width="416" height="416" loading="lazy">
	  </li>`;

  var _html2 = `
		  <li class="product__media-item swiper-slide">
			  <div class="product-media-container media-type-image media-fit- global-media-settings gradient" style="--ratio: 1.0; --preview-ratio: 1.0;">
			  <div class="product__media media media--transparent">
				  <img alt="[title]" src="[image]&amp;width=1946" srcset="[image]&amp;width=246 246w, [image]&amp;width=493 493w, [image]&amp;width=600 600w, [image]&amp;width=713 713w, [image]&amp;width=823 823w, [image]&amp;width=990 990w, [image]&amp;width=1100 1100w, [image]&amp;width=1206 1206w, [image]&amp;width=1346 1346w, [image]&amp;width=1426 1426w, [image]&amp;width=1646 1646w, [image]&amp;width=1946 1946w" width="1946" height="1946" loading="lazy" class="image-magnify-" sizes="(min-width: 1300px) 48000px, (min-width: 990px) calc(4000vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
			  </div>
			  </div>
		  </li>
	  `;
  var _html3 = `
		  <ul class="product__media-list list-unstyled swiper-wrapper" role="list">
			  [content]
		  </ul>
		  <div class="swiper-pagination large-up-hide medium-hide"></div>
		  <div class="swiper-button-prev large-up-hide"></div>
		  <div class="swiper-button-next large-up-hide"></div>
	  `;
  customElements.define(
    "product-options",
    class ProductOptions extends HTMLElement {
      constructor() {
        super();
        this.product = null;
        this.galleryMedia = document.querySelector("#MediaGallery");
        this.inputs = this.querySelectorAll("input.option-value");
        this.data = JSON.parse(
          this.querySelector('[type="application/json"]')?.textContent
        );

        console.log("Data ", this.data);
        this.init();
      }

      init() {
        this.fistRowSelection();
        this.inputs.forEach((input) =>
          input.addEventListener("change", () => {
            this.handleInputChange(input);
          })
        );
      }

      connectedCallback() {
        this.optionSelectUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionSelect,
          (event) => {
            this.handleInputChange(event.input);
          }
        );

        this.productSelectUnsubscriber = subscribe(
          PUB_SUB_EVENTS.productSelect,
          (event) => {
			this.product = event.product;
            this.updateProductDetails(event.product);
            this.changeImages(event.key, event.product);
            this.updateGradePrices(event.key);
            this.setSelectedProductPrice(event.key, event.product);
          }
        );

        subscribe(PUB_SUB_EVENTS.cartUpdate, (obj) => {
			console.log('1. adding special note to cart update');
            if (!localStorage.getItem('specialNote')) 
              	return;

			console.log('currentProduct ', this.product);
			console.log('2. special note found in local storage');
            const note = localStorage.getItem('specialNote').split('#')[0];
			const productId = localStorage.getItem('specialNote').split('#')[1];
			console.log('note <===> ', note);

			if (this.product.id != productId) 
				return;
            setTimeout(async () => {
                const body = JSON.stringify({ note });
                await fetch(`${routes.cart_update_url}`, {
                    ...fetchConfig(),
                    ...{ body },
                });
				console.log('3. special note added');
				localStorage.removeItem('specialNote');
                // document.querySelector("#CartDrawer-Note").textContent = note;
            }, 1000);
        });

        /*
        * remove ssetting option from options group
        * add it on the desscription section
        */
        const settingOption = this.querySelector('popup-opener.option-setting').cloneNode(true);
        const descriptionSection = document.querySelector('.product__description');
        settingOption.style.display = 'block';
        settingOption.classList.add('setting-description-section');
        if (descriptionSection) {
            descriptionSection.insertAdjacentElement('beforebegin', settingOption);
        }

        this.initializeSelection();
      }

      replaceAll(string, search, replace) {
        return string.split(search).join(replace);
      }

      changeImages(key, product) {
        let imgSliderHTML = ``;
        let thumbHTML = ``;
        product.images.forEach((img, i) => {
          let h = _html2;
          h = this.replaceAll(h, "[image]", img);
          h = this.replaceAll(h, "[title]", product.name);
          imgSliderHTML += h;

          let h2 = _html;
          h2 = this.replaceAll(h2, "[image]", img);
          h2 = this.replaceAll(h2, "[title]", product.name);
          h2 = this.replaceAll(h2, "[position]", i + 1);
          thumbHTML += h2;
        });

        if (product.images.length < 2) {
          thumbHTML = ``;
          this.galleryMedia
            .querySelector(".thumbnail-list")
            .classList.add("hidden");
        } else {
          this.galleryMedia
            .querySelector(".thumbnail-list")
            .classList.remove("hidden");
        }

        let slidetmph = _html3;
        slidetmph = slidetmph.split("[content]").join(imgSliderHTML);

        this.galleryMedia.querySelector(".thumbnail-list ul").innerHTML =thumbHTML;
        this.galleryMedia.querySelector(".main-image .swiper").innerHTML =slidetmph;
        this.galleryMedia.setAttribute("data-product", product.id);
        // document.querySelector("#MediaGallery").init();
      }

      disconnectedCallback() {
        if (this.optionSelectUnsubscriber) {
          this.optionSelectUnsubscriber();
        }
        if (this.productSelectUnsubscriber) {
          this.productSelectUnsubscriber();
        }
      }

      /**
       * detect the available options on the third row and configure the prices
       * disable the unavailable ones
       */
      fistRowSelection() {
        const options = this.querySelectorAll(
          ".product-option--2 input.option-value"
        );
        let currentKey = this.data.current["options-key"];

        options.forEach((opt) => {
          currentKey = currentKey.split("_").slice(0, 2);
          currentKey = `${currentKey.join("_")}_${opt.value}`;

          let availableProducts = [];
          if (!this.data.current["options-key"].startsWith(currentKey)) {
            availableProducts = this.data.products?.filter(
              (pr) =>
                pr["options-key"].startsWith(currentKey) &&
                pr.availability == "InStock"
            );
          }

          if (!availableProducts.length) {
            opt.setAttribute("disabled", true);
            return;
          }
          availableProducts.sort((p1, p2) =>
            p1.price < p2.price ? -1 : p1.price > p2.price ? 1 : 0
          );

          this.querySelector(
            `.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`
          ).textContent = `${availableProducts[0].currencySymbol}${availableProducts[0].price}`;

            const tag = availableProducts[0].tags.find(t => t.startsWith('mk')); 
            const tagValue = tag.split('mk_')[1].toLowerCase();  
			if (tagValue.toString().includes('alloy')) {
				tagValue = 'n-a-alloy';
			};
            
            this.querySelector(`.metal-carat--${tagValue} .diamond-quality`).innerText = availableProducts[0].optionsValue.option2;

          try {
            let comparedPrice1 =
              availableProducts[0].comparedPrice == ""
                ? ""
                : parseFloat(
                    availableProducts[0].comparedPrice
                      .replace(",", "")
                      .replace(".", "")
                  ) * 100;
            this.querySelector(
              `.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`
            ).classList.remove("wpd-processed");
            this.querySelector(
              `.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`
            ).setAttribute("data-wpd-variant-compare-at-price", comparedPrice1);
            this.querySelector(
              `.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`
            ).setAttribute(
              "data-wpd-variant-price",
              parseFloat(
                availableProducts[0].price.replace(",", "").replace(".", "")
              ) * 100
            );
            this.querySelector(
              `.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`
            ).setAttribute("data-wpd-variant-id", availableProducts[0].variant);
            this.querySelector(
              `.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`
            ).setAttribute(
              "data-wpd-product-handle",
              window.wpdExtensionIsProductPage.handle
            );
          } catch (e) {}
        });

        this.disableAllOptions();
      }

      /**
       *disable all options if no first option is available
       * @param {*}
       * @returns
       */
      disableAllOptions() {
        let firstAvailable = this.querySelector(
          `.product-option--0 input.option-value:not([disabled])`
        );
        let options = this.querySelectorAll(`input.option-value`);
        if (!firstAvailable) {
          options.forEach((opt) => opt.setAttribute("disabled", true));
        }
      }

      /**
       * handle the selection on an input and trigger the selection of the next line of options
       * @param {*} input
       * @returns
       */
      handleInputChange(input) {
        let key = "";
        if (input == null) return;

        const index = parseInt(input.dataset.index);
        if (index == 0) {
          key = input.value;
        } else {
          key = this.getKeyFromPreviousSelections(index);
          key += `_${input.value}`;
        }
        // if (input.dataset.value.includes('alloy')) {
        // 	this.querySelector(`.product-option--${index + 1}`).classList.add('hidden');
        // } else {
        // 	this.querySelector(`.product-option--${index + 1}`).classList.remove('hidden');
        // }

        this.querySelector(
          `.product-option__header-value--${index}`
        ).innerHTML = input.dataset.value;
        if (input.classList.contains("last-option")) {
          return this.getProductByKey(key);
        }

        return this.triggerNextInputSelection(key, index + 1);
      }

      /**
       * automaticaly trigger the selection of the first available option
       */
      initializeSelection() {
        let firstAvailable = this.querySelector(
          `input.option-value:not([disabled])[data-index="0"]:checked`
        );
        if (!firstAvailable) {
          firstAvailable = this.querySelector(
            `input.option-value:not([disabled])[data-index="0"]`
          );
        }

        firstAvailable.checked = true;

        return publish(PUB_SUB_EVENTS.optionSelect, { input: firstAvailable });
      }

      /**
       * return the key based on the previously selected options
       * @param {*} index
       * @returns
       */
      getKeyFromPreviousSelections(index) {
        let key = "";
        for (let i = 0; i < index; i++) {
          if (i != 0) key += "_";
          key += this.querySelector(
            `input.option-value[data-index="${i}"]:checked`
          ).value;
        }

        return key;
      }

      /**
       * check a line of options disable the unavailables and select one available
       * it's a recursive function that check the next line after it's done with the current one
       * @param {*} key
       * @param {*} index
       * @returns
       */
      triggerNextInputSelection(key, index) {
        let Okey = key;
        let nextInputs = this.querySelectorAll(
          `input.option-value[data-index="${index}"]`
        );

        nextInputs.forEach((ipt) => {
          let k = key + "_" + ipt.value;
          if (!ipt.classList.contains('last-option')) {
            k += "_";
          }
          if (!this.checkProductsFromKey(k)) {
            return ipt.setAttribute("disabled", true);
          }

          return ipt.removeAttribute("disabled");
        });

        let checkedInput = this.querySelector(
          `input.option-value:not([disabled])[data-index="${index}"]:checked`
        );
        if (checkedInput) {
          key += "_" + checkedInput.value;
          this.querySelector(
            `.product-option__header-value--${index}`
          ).innerHTML = checkedInput.dataset.value;
          if (checkedInput.classList.contains("last-option")) {
            if (this.hasProductsFromKey(key)) {
              return this.getProductByKey(key);
            }

            checkedInput.removeAttribute("checked");
            let alternative = null;
            nextInputs.forEach((ipt) => {
              let k = Okey + "_" + ipt.value;
              if (this.hasProductsFromKey(k)) {
                ipt.checked = true;
                alternative = ipt;
              }
            });

            if (alternative == null) {
              this.disableAddButton();
              let product = { name: "" };

              Okey.split("_")
                .slice(0, -1)
                .forEach((element, index) => {
                  if (index == 3)
                    product.name += " " + this.data.current.collection;
                  product.name += ` ${element}`;
                });

              this.updateHeaderTitle(product);
            }
            return publish(PUB_SUB_EVENTS.optionSelect, { input: alternative });
          }

          return this.triggerNextInputSelection(key, index + 1);
        }

        let firstAvailable = this.querySelector(
          `input.option-value:not([disabled])[data-index="${index}"]`
        );
        if (firstAvailable == null) {
          this.disableAddButton();
          let product = { name: "" };
          Okey.split("_")
            .slice(0, -1)
            .forEach((element, index) => {
              if (index == 3)
                product.name += " " + this.data.current.collection;
              product.name += ` ${element.toLowerCase().replace("-", " ")}`;
            });

          this.updateHeaderTitle(product);
          return;
        }

        firstAvailable.checked = true;
        key += "_" + firstAvailable.value;
        this.querySelector(
          `.product-option__header-value--${index}`
        ).innerHTML = firstAvailable.dataset.value;

        if (firstAvailable.classList.contains("last-option"))
          return this.getProductByKey(key);
        return publish(PUB_SUB_EVENTS.optionSelect, { input: firstAvailable });
      }

      /**
       * check the current key has available products
       * @param {*} key
       * @returns
       */
      checkProductsFromKey(key) {
        let availableProducts = this.data.products?.filter(
          (pr) =>
            pr["options-key"].startsWith(key) && pr.availability == "InStock"
        );
        return availableProducts.length;
      }

      /**
       * display prices for each first combination
       * @param {*} key
       * @param {*} product
       */
      setSelectedProductPrice(key, product) {
        if (product.type == 'Rolex Bezels') return;
        let firstAvailable = this.querySelector(
          `input.option-value:not([disabled])[data-index="2"]:checked`
        );
        if (firstAvailable) {
          this.querySelector(
            `.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`
          ).textContent = `${product.currencySymbol}${product.price}`;

            const tag = product.tags.find(t => t.startsWith('mk')); 
            let tagValue = tag.split('mk_')[1].toLowerCase();  
            if (tagValue.toString().includes('alloy')) {
              tagValue = 'n-a-alloy';
            };
            this.querySelector(`.metal-carat--${tagValue} .diamond-quality`).innerText = product.optionsValue.option2;
            
          let comparedPrice1 =
                product.comparedPrice == ""
                  ? ""
                  : parseFloat(
                      product.comparedPrice.replace(",", "").replace(".", "")
                    ) * 100;
           this.querySelector(
            `.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`
          ).classList.remove("wpd-processed");
              this.querySelector(
            `.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`
          ).setAttribute(
                "data-wpd-variant-compare-at-price",
                comparedPrice1
              );
              this.querySelector(
            `.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`
          ).setAttribute(
                "data-wpd-variant-price",
                parseFloat(product.price.replace(",", "").replace(".", "")) *
                  100
              );
              this.querySelector(
            `.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`
          ).setAttribute("data-wpd-variant-id", product.variant);
        }
      }

      hasProductsFromKey(key) {
        let availableProducts = this.data.products?.filter((pr) =>
          pr["options-key"].startsWith(key)
        );
        return availableProducts.length;
      }

      /**
       *
       * @param {*} key
       * @returns
       */
      getProductByKey(key) {
        let product = this.data.products?.find((pr) =>
          pr["options-key"].startsWith(key)
        );
        return publish(PUB_SUB_EVENTS.productSelect, { product, key });
      }

      updateProductDetails(product) {
        this.updateHeaderPrice(product);
        this.updateAddButton(product);
        this.updateHeaderTitle(product);
        this.updateDecription(product);
        this.updateIconPicto(product);
        this.updateBreadcrumb(product);
        this.updateAddonInfo(product);
        this.updateFactoryTag(product);
		this.updateSKU(product.sku);
        this.updateSettingsDescription(product);
      }

      updateHeaderPrice(product) {
        document
          .querySelectorAll(".product-head__price .price")
          .forEach((priceElement) => {
            priceElement.textContent = `${product.currencySymbol}${product.price}`;

            try {
              let comparedPrice1 =
                product.comparedPrice == ""
                  ? ""
                  : parseFloat(
                      product.comparedPrice.replace(",", "").replace(".", "")
                    ) * 100;
              priceElement.classList.remove("wpd-processed");
              priceElement.setAttribute(
                "data-wpd-variant-compare-at-price",
                comparedPrice1
              );
              priceElement.setAttribute(
                "data-wpd-variant-price",
                parseFloat(product.price.replace(",", "").replace(".", "")) *
                  100
              );
              priceElement.setAttribute("data-wpd-variant-id", product.variant);
              priceElement.setAttribute(
                "data-wpd-product-handle",
                window.wpdExtensionIsProductPage.handle
              );
            } catch (e) {}
          });
        // document.querySelectorAll('.product-head__price .compare-price').forEach(priceElement => {
        // 	if (product.comparedPrice == '') {
        // 		priceElement.classList.add('hidden');
        // 	} else {
        // 		priceElement.classList.remove('hidden');
        // 	}
        // 	priceElement.textContent = `${product.currencySymbol}${product.comparedPrice}`;
        // });
        document.querySelector(
          ".product-price-mobile"
        ).textContent = `${product.currencySymbol}${product.price}`;
        document
          .querySelectorAll(".product-availability")
          .forEach((productAvaibility) => {
            productAvaibility.classList.add(
              `${
                product.availability == "InStock"
                  ? "product__in-stock"
                  : "product__sold-out"
              }`
            );
          });
      }

      updateAddonInfo(product) {
        if (document.querySelector(".product__add-on") == null) 
          return;

        document
          .querySelector(".product__add-on input")
          .removeAttribute("disabled");
        if (product.add_on == null) {
          document.querySelector(".product__add-on input").checked = false;
          document
            .querySelector(".product__add-on input")
            .setAttribute("disabled", false);

          return;
        }
        document.querySelector(".product__add-on").dataset.variantId =
          product.add_on.id;
        document.querySelector(".product__add-on .add-on__price").textContent =
          product.add_on.price;

        try {
          document.querySelector(".product__add-on .add-on__price").classList.remove("wpd-processed");
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-variant-compare-at-price", "");
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-variant-price",parseFloat(product.add_on.price.replace(",", "").replace(".", "").replace("$", "")) * 100);
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-variant-id", product.add_on.id);
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-product-handle", this.product.handle);
        } catch (e) {}
      }

      updateDecription(product) {
        if (document.querySelector(".product__description")) {
            document.querySelector(".product__description").innerHTML = product.description;
        }
      }

      updateIconPicto(product) {
        if (product.featured_image !== null)
          this.querySelector(".icon-picto img").setAttribute(
            "src",
            product.featured_image
          );
      }

      updateGradePrices(key) {
        if (this.querySelector('.grade-price') == null) return;

        let partialKey = key.split("_");
        partialKey = partialKey.slice(0, 2).join("_");
        const options = this.querySelectorAll(
          ".product-option--2 input.option-value"
        );

        options.forEach((option) => {
          let value = option.value;
          let nextGroupSeletedInput = this.querySelector(
            `.product-option--${
              parseInt(option.dataset.index) + 1
            } input.option-value:checked`
          ).value;
          let updatedKey = `${partialKey}_${value}_${nextGroupSeletedInput}`;
          let productAvailable = this.data.products.filter((product) =>
            product["options-key"].includes(updatedKey)
          );

          productAvailable.forEach((product, index) => {
            if (
                document.querySelector(`.product-option__list-item--${value} .grade-price`)
            ) {
                const tag = product.tags.find(t => t.startsWith('mk')); 
                let tagValue = tag.split('mk_')[1].toLowerCase(); 
                if (tagValue.toString().includes('alloy')) {
                  tagValue = 'n-a-alloy';
                };
                this.querySelector(`.metal-carat--${tagValue} .diamond-quality`).innerText = product.optionsValue.option2;
            }

            if (index == 0) {
                if (
                    document.querySelector(`.product-option__list-item--${value} .grade-price`)
                )
                    document.querySelector('.template-product .product-head__price').innerHTML ='';
                    document.querySelector(
                        `.product-option__list-item--${value} .grade-price`
                    ).innerHTML = `${product.currencySymbol}${product.price}`;

                    try {
                        let comparedPrice1 =
                        product.comparedPrice == ""
                            ? ""
                            : parseFloat(
                                product.comparedPrice.replace(",", "").replace(".", "")
                            ) * 100;
                        document.querySelector(
                            `.product-option__list-item--${value} .grade-price`
                        ).classList.remove("wpd-processed");
                        document.querySelector(
                            `.product-option__list-item--${value} .grade-price`
                        ).setAttribute(
                            "data-wpd-variant-compare-at-price",
                            comparedPrice1
                        );
                        document.querySelector(
                            `.product-option__list-item--${value} .grade-price`
                        ).setAttribute(
                            "data-wpd-variant-price",
                            parseFloat(
                            product.price.replace(",", "").replace(".", "")
                            ) * 100
                        );
                        document.querySelector(
                            `.product-option__list-item--${value} .grade-price`
                        ).setAttribute("data-wpd-variant-id", product.variant);
                        document.querySelector(
                            `.product-option__list-item--${value} .grade-price`
                        ).setAttribute(
                            "data-wpd-product-handle",
                            this.product.handle
                        );
                    } catch (e) {}
                } else {
                    return;
                }
            });
        });
      }

      updateAddButton(product) {
        let forms = document.querySelectorAll(".product-form");
        forms.forEach((form) => {
          form.querySelector('[name="id"]').value = product.variant;

          if (product.availability == "InStock") {
            form.querySelector('[name="add"] span:first-child').innerHTML =
              this.data.strings.add_to_cart;
            form.querySelector('[name="add"]').removeAttribute("disabled");
            return;
          }

          form.querySelector('[name="add"] span:first-child').innerHTML =
            this.data.strings.sold_out;
          form.querySelector('[name="add"]').setAttribute("disabled", true);
          return;
        });
      }

      disableAddButton() {
        let forms = document.querySelectorAll(".product-form");
        forms.forEach((form) => {
          form.querySelector('[name="add"]').setAttribute("disabled", true);
        });
      }

      updateHeaderTitle(product) {
        const productNames = document.querySelectorAll(
          ".product-head__title-keys"
        );

        productNames.forEach((productName) => {
          productName.innerHTML = product.name;
        });
      }

	  updateSKU(sku) {
		document.querySelector(".product__sku").innerHTML = `<span class="visually-hidden">SKU:</span>${sku}`;
	  }

      updateSettingsDescription(product) {
        if (
            document.querySelector(".setting-description-section .option-value")
        ) {
            document.querySelector(".setting-description-section .option-value").innerText = product.optionsValue.option1;
        }
      }

      updateBreadcrumb(product) {
        document.querySelector(".breadcrumbs [aria-current]").innerText =
          product.name;
      }

      updateFactoryTag(product) {
        if(product.tags.includes("Factory")) {
          this.querySelector(".product-tag__factory")?.classList.remove("hidden");
          document.querySelector('.type-blank-bezel').style.display = 'flex';
        } else {
            document.querySelector('.type-blank-bezel').style.display = 'none';
            this.querySelector(".product-tag__factory")?.classList.add("hidden");
        }
      }
    }
  );
}

if (!customElements.get("watch-reference")) {
  customElements.define(
    "watch-reference",
    class WatchReference extends HTMLElement {
      constructor() {
        super();
        this.productsGroup = JSON.parse(
          document.querySelector('product-options [type="application/json"]')
            ?.textContent
        );
        this.inputSearch = this.querySelector("input");
        this.resetButton = this.querySelector(".icon-close");
        this.submitButton = this.querySelector(".submit-reference");
        this.note = this.dataset.note;
        this.filteredProducts = [];
        this.productMatch = null;

        this.referenceList = JSON.parse(
          this.querySelector('[type="application/json"]')?.textContent
        );
      }

      connectedCallback() {
        this.registerEventListner();
        this.optionRows = parseInt(document.querySelector(".option.last-option input").dataset.index) + 1;

        subscribe(PUB_SUB_EVENTS.cartUpdate, (obj) => {
          const note = `${this.inputSearch.value} ${this.note}`;
          setTimeout(() => {
            if (this.inputSearch.value == "") return;

            const body = JSON.stringify({ note });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
            document.querySelector("#CartDrawer-Note").textContent = note;
          }, 1000);
        });
      }

      registerEventListner() {
        this.inputSearch.addEventListener(
          "input",
          debounce(this.handleInputSearch.bind(this), ON_CHANGE_DEBOUNCE_TIMER)
        );
        this.inputSearch.addEventListener(
          "keydown",
          debounce(this.handleSearchSubmit.bind(this), ON_CHANGE_DEBOUNCE_TIMER)
        );
        this.submitButton.addEventListener(
          "click",
          debounce(this.handleSearchSubmit.bind(this), ON_CHANGE_DEBOUNCE_TIMER)
        );
        this.resetSearch();
      }

      // handleSearchSubmit(event) {
      //   if (event.keyCode == 13 || event.target.dataset.event == "submit") {
      //     if (this.inputSearch.value == "") return;
      //     let watchInfo = this.getWatchInfo();

      //     this.inputSearch.setAttribute("disabled", true);
      //     this.querySelector(".icon-close").classList.add("show");

      //     if (this.filteredProducts.length > 0) {
      //       this.productMatch = null;
      //       this.filteredProducts.forEach((filteredProduct) => {
      //         if (
      //           filteredProduct["options-key"].split("_").length ==
      //           this.optionRows
      //         )
      //           this.productMatch = filteredProduct;
      //       });

      //       const splitedKey = this.productMatch["options-key"].split("_");
      //       for (let index = 0; index <= 1; index++) {
      //         let element = document.querySelector(
      //           `.product-option__list-item--${splitedKey[index]} label`
      //         );
      //         element.click();
             
      //         let popupOpener = element.closest("popup-opener");
      //         if (popupOpener) {
      //           if (popupOpener.classList.contains("product-option--0")) {
      //             popupOpener.classList.add("option-locked");
      //             popupOpener.querySelector(".tag-value").textContent = this.inputSearch.value;
      //           }
      //         }
      //       }
      //     }

      //     console.log("productmatch", this.productMatch);
      //     console.log("optionrows", this.optionRows);

      //     if (watchInfo.length > 0) {
      //       this.inputSearch.value = `${this.inputSearch.value} (${watchInfo[0]["Model Name"]})`;
            
      //       console.log("this.inputSearch.value", watchInfo[0]["Vintage or Special Situation"]);
      //       if (this.productMatch !== null) {
      //         if (this.productMatch.tags.includes("vintage") &&  watchInfo[0]["Vintage or Special Situation"] !== null ) {
      //           this.querySelector(".vintage-note").classList.remove("hidden");

      //           const container = this.querySelector(".vintage-note")
      //           const existingTable = container.querySelector(".watch-info");
      //           if (existingTable) {
      //             existingTable.remove();
      //           }
      //           watchInfo.forEach((watch) => {
      //             let watchDiv = document.createElement("div");
      //             watchDiv.classList.add("watch-info");
      //             watchDiv.innerHTML = `
      //              <span><strong>Model Name: </strong>${watch["Model Name"]}</span>
      //              <span><strong>Material: </strong>${watch["Material"]}</span>
      //              <span><strong>Case Size: </strong>${watch["Case Size"]}</span>
      //              <span><strong>Bezel Color: </strong>${watch["Color"]}</span>
      //              <span><strong>Diamond Bezel Size: </strong>${watch["Diamond Bezel Size"]}</span>
      //              <span><strong>Vintage or Special Situation: </strong>${watch["Vintage or Special Situation"]}</span> 
                   
      //           `;

      //             container.appendChild(watchDiv);
      //           });
      //         } else {
      //           this.querySelector(".vintage-note").classList.add("hidden");
      //         }
      //       }
      //     }
      //   }
      // }

 handleSearchSubmit(event) {
        if (event.keyCode == 13 || event.target.dataset.event == "submit") {
          if (this.inputSearch.value == "") return;
          let watchInfo = this.getWatchInfo();

          this.inputSearch.setAttribute("disabled", true);
          this.querySelector(".icon-close").classList.add("show");

          if (this.filteredProducts.length > 0) {
            this.productMatch = null;
            this.filteredProducts.forEach((filteredProduct) => {
              if (
                filteredProduct["options-key"].split("_").length ==
                this.optionRows
              )

                this.productMatch = filteredProduct;
            });

            const splitedKey = this.productMatch["options-key"].split("_");
            for (let index = 0; index <= 1; index++) {
              let element = document.querySelector(
                `.product-option__list-item--${splitedKey[index]} label`
              );
              element.click();
             
              let popupOpener = element.closest("popup-opener");
              if (popupOpener) {
                // if (popupOpener.classList.contains("product-option--0")) {
                //   popupOpener.classList.add("option-locked");
                //   popupOpener.querySelector(".tag-value").textContent = this.inputSearch.value;
                // }
				popupOpener.classList.add("option-locked");
				popupOpener.querySelector(".tag-value").textContent = this.inputSearch.value;
              }
            }
          }

          if (watchInfo.length > 0) {
            this.inputSearch.value = `${this.inputSearch.value} (${watchInfo[0]["Model Name"]})`;
            
                const container = this.querySelector(".vintage-note")
                const existingTable = container.querySelector(".watch-info");
                if (existingTable) {
                  existingTable.remove();
                }
                watchInfo.forEach((watch) => {
                  let watchDiv = document.createElement("div");
                  watchDiv.classList.add("watch-info");
                  watchDiv.innerHTML = `
                   <span><strong>Model Name: </strong>${watch["Model Name"]}</span>
                   <span><strong>Material: </strong>${watch["Material"]}</span>
                   <span><strong>Case Size: </strong>${watch["Case Size"]}</span>
                   <span><strong>Bezel Color: </strong>${watch["Color"]}</span>
                   <span><strong>Diamond Bezel Size: </strong>${watch["Diamond Bezel Size"]}</span>
                   <span><strong>Vintage or Special Situation: </strong>${watch["Vintage or Special Situation"] !== null ? watch["Vintage or Special Situation"] : "None"}</span> 
                   
                `;

                  container.appendChild(watchDiv);
                });
            if (this.productMatch !== null) {
              if (this.productMatch.tags.includes("vintage") &&  watchInfo[0]["Vintage or Special Situation"] !== null ) {
                this.querySelector(".vintage-note").classList.remove("hidden");

              } else {
                this.querySelector(".vintage-note").classList.remove("hidden");
              }
            }
          }
          else{
                const container = this.querySelector(".vintage-note")
                const existingTable = container.querySelector(".watch-info");
                if (existingTable) {
                  existingTable.remove();
                }
                  let watchDiv = document.createElement("div");
                  watchDiv.classList.add("watch-info");
                  watchDiv.innerHTML = `
                   <span>Fit information is not available for this reference. Please contact us</span>                   
                `;

                  container.appendChild(watchDiv);
                  this.querySelector(".vintage-note").classList.remove("hidden");
          }
        }
      }

      handleInputSearch(event) {
        const searchValue = event.target.value;
        this.filteredProducts = this.productsGroup.products.filter((product) =>
          product.tags.includes(searchValue.toLowerCase())
        );
      }

      getWatchInfo() {
        let watchInfo = this.referenceList.items.filter(
          (item) => item["Reference Number"] == this.inputSearch.value
        );

        return watchInfo;
      }

      resetSearch() {
        this.resetButton.addEventListener("click", (event) => {
          this.filteredProducts = [];
          this.inputSearch.removeAttribute("disabled");
          this.inputSearch.value = "";
          this.querySelector(".icon-close").classList.remove("show");

          this.querySelector(".vintage-note").classList.add("hidden");

          for (let index = 0; index <= 1; index++) {
            document
              .querySelector(`.product-option__list-item--${index} label`)
              .closest("popup-opener")
              .classList.remove("option-locked");
          }
        });
      }
    }
  );
}

if (!customElements.get("product-add-on")) {
  customElements.define(
    "product-add-on",
    class ProductAddOn extends HTMLElement {
      constructor() {
        super();

        this.addOnId = this.dataset.variantId;
        this.currentProduct = document.querySelector(
          ".product-variant-id"
        ).value;

        this.querySelector('.switch input').removeAttribute('disabled');
      }

      connectedCallback() {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!this.querySelector("label input").checked) return;
          this.addOnId = this.dataset.variantId;
          this.currentProduct = document.querySelector(
            ".product-variant-id"
          ).value;

          setTimeout(() => {
            document.querySelector(".product-variant-id").value = this.addOnId;
            document.querySelector(".product-form__submit").click();
            document.querySelector(".product-variant-id").value =
              this.currentProduct;
          }, 1000);

          this.querySelector("label input").click();
        });
      }
    }
  );
}


// document.querySelectorAll(".template-product popup-opener").forEach((opener) => {
//     opener.addEventListener("click", function () {
//         if (this.classList.contains("option-locked")) {
//             this.classList.remove("option-locked");
//         }
//     });
// });